import {combineReducers} from 'redux';
import itemReducer from './item-reducer';
import assigneeReducer from './assignee-reducer';
import loginReducer from './login-reducer';
import accountReducer from './account-reducer';
import workSessionReducer from './work-session-reducer';
import workSessionTemplateReducer from './work-session-template-reducer';
import currentWorkSessionReducer from './current-work-session-reducer';
import groupsReducer from './groups-reducer';
import mutationReducer from './mutation-reducer';
import Immutable from 'immutable';
import {toImmutable, fromLocalStorage} from '../../utils';
import moment from 'moment';
//import mutationReducer from './mutation-reducer';
const savedAccountState = fromLocalStorage('accountState');
const savedLoginState = fromLocalStorage('loginState');

export const InitialState = {
    accountState:toImmutable(
        savedAccountState ? savedAccountState : {
                lastLoadSuccess:null,
                lastSaveSuccess:null,
                loading:false,
                loadingFailed:false,
                saving:false,
                savingFailed:false,
                account:{},
            }
    ),
    loginState:toImmutable(
        savedLoginState ? savedLoginState : {
                loginTimestamp:null,
                loggedIn:false,
                loginProgress:null, // null|user|server  - waiting for user input, waiting for server
                loginFailed:false,
                loginAborted:false, // user don't want to log in.. do not try to do anything that requires logging in.
                errorMessage:"" // if login failed, we might get a reason
            }
    ),
    workSessionsState:toImmutable(
        {
            lastLoadSuccess:null,
            // lastSaveSuccess:null,
            loading:false,
            loadingFailed:false,
            // saving:false,
            // savingFailed:false,
            workSessions:{},
            currentWorkSession:null
        }
    ),
    currentWorkSessionState:toImmutable(
        {
            lastLoadSuccess:null,
            lastSaveSuccess:null,
            loading:false,
            loadingFailed:false,
            saving:false,
            savingFailed:false,
            // data goes here
        }
    ),
    workSessionTemplatesState:toImmutable(
        {
            lastLoadSuccess:null,
            // lastSaveSuccess:null,
            loading:false,
            loadingFailed:false,
            // saving:false,
            // savingFailed:false,
            workSessionTemplates:{},
        }
    ),
    groupsState:toImmutable(
        {
            lastLoadSuccess:moment(),
            updateTime:null,
            loading:false,
            loadingFailed:false,
            groups:{
                1:{
                    id:'1',
                    name:'Night Shift',
                    shortName:'NS',
                    itemAssignable:false,
                    color:'#ad95ff '
                },
                2:{
                    id:'2',
                    name:'Day Shift',
                    shortName:'DS',
                    itemAssignable:false,
                    color:'#ad95ff '
                },
                3:{
                    id:'3',
                    name:'Beta',
                    shortName:'ß',
                    itemAssignable:true,
                    color:'#ad95ff '
                },
                4:{
                    id:'4',
                    name:'Trainee Level 1',
                    shortName:'T1',
                    itemAssignable:true,
                    color:'#ad95ff '
                },
            },

        }
    ),
    assigneesState:toImmutable(
        {
            lastLoadSuccess:null,
            lastSaveSuccess:null,
            updateTime:null,
            loading:false,
            loadingFailed:false,
            saving:false,
            savingFailed:false,
            assignees:{},
        }
    ),
    itemsState:toImmutable(
        {
            lastLoadSuccess:null,
            lastSaveSuccess:null,
            loading:false,
            loadingFailed:false,
            saving:false,
            savingFailed:false,
            searchItemsIds:[],
            items:{}
        }
    ),
    mutationsState:Immutable.Map(), //Immutable.Map({
        /*
        [worksessionId]:{
            [editorId]:{
                [type]:{ // entity type, if editor handles many types
                    [entityId]:{
                        [property]:{
                                {added: [value1, value2]},
                                {removed:[value3, value4]},
                                {set:value}
                         }
                    }
                }
            }
        }
        */
    //})
};
const appReducer = combineReducers(
    {
        loginState:loginReducer,
        accountState:accountReducer,
        itemsState:itemReducer,
        assigneesState:assigneeReducer,
        workSessionsState:workSessionReducer,
        workSessionTemplatesState:workSessionTemplateReducer,
        currentWorkSessionState:currentWorkSessionReducer,
        groupsState:groupsReducer,
        mutationsState:mutationReducer,
    }
);

export default appReducer;


// WEBPACK FOOTER //
// ./src/model/reducers/index.js